// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuestionScreen__loader___IN7f5 {
    font-size: 10px;
    margin: 50px auto;
    text-indent: -9999em;
    width: 2vw;
    height: 2vw;
    border-radius: 50%;
    background: #6060FF;
    background: -moz-linear-gradient(left, #6060FF 10%, rgba(255, 255, 255, 0) 42%);
    background: -webkit-linear-gradient(left, #6060FF 10%, rgba(255, 255, 255, 0) 42%);
    background: -o-linear-gradient(left, #6060FF 10%, rgba(255, 255, 255, 0) 42%);
    background: -ms-linear-gradient(left, #6060FF 10%, rgba(255, 255, 255, 0) 42%);
    background: linear-gradient(to right, #6060FF 10%, rgba(255, 255, 255, 0) 42%);
    position: relative;
    -webkit-animation: QuestionScreen__load3___bHL6r 1.4s infinite linear;
    animation: QuestionScreen__load3___bHL6r 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
}

.QuestionScreen__loader___IN7f5:before {
    width: 50%;
    height: 50%;
    background: #6060FF;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
}

.QuestionScreen__loader___IN7f5:after {
    background: #ffffff;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

@-webkit-keyframes QuestionScreen__load3___bHL6r {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes QuestionScreen__load3___bHL6r {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@media screen and (max-width: 1100px) {
    .QuestionScreen__loader___IN7f5 {
        width: 10vw;
        height: 10vw;
    }

    .QuestionScreen__stiiick___how8q {
        width: 40vw;
        height: 10vw;
        padding: 2.5vw
    }

    .QuestionScreen__headerContainer___wo0SM {
        width: 100vw;
        height: 10vh;
        border-bottom: lightgrey 1px solid;
        margin-top: -7vh;
    }

    .QuestionScreen__ask___QHDCu {
        color: red;
        font-size: 4vw;
    }

    .QuestionScreen__have___vTLkc {
        margin-top: 3vh;
        text-align: center;
    }

    .QuestionScreen__headerTitle___nPWeH {
        text-align: center;
    }

    .QuestionScreen__form___BUF3_ {
        align-items: center;
        display: flex;
        flex-direction: column;
    }

    .QuestionScreen__input___vjUUf {
        width: 80vw;
        height: 30vh;
        border-radius: 5vw;
        border: 1px #6060FF solid;
        padding: 5vw;
        font-size: 4vw;
        margin-top: 5vh;
    }

    .QuestionScreen__emailInput___Tl713 {
        width: 80vw;
        height: 5vh;
        padding: 2vw;
        border-radius: 5vw;
        border: 1px #6060FF solid;
        font-size: 4vw;
        margin-top: 1vh;
    }

    .QuestionScreen__emailInput___Tl713:focus {
        outline: none;
    }

    .QuestionScreen__input___vjUUf:focus {
        outline: none;
    }

    .QuestionScreen__contact___FKnEr {
        color: #6060FF;
        margin-top: 5vh;
        text-align: center;
        font-size: 4vw;
    }
    .QuestionScreen__send___KNjrl {
        color: #6060FF;
        font-weight: bold;
        margin-top: 7vh;
        cursor: pointer;
    }

    .QuestionScreen__thank___kkZJC {
        text-align: center;
        margin-top: 5vh;
    }
}

@media screen and (min-width: 1100px) {
    .QuestionScreen__stiiick___how8q {
        width: 28vh;
        height: 7vh;
        padding: 1vw;
        object-fit: contain;
        padding-left: 15vw;
    }

    .QuestionScreen__headerContainer___wo0SM {
        width: 100vw;
        height: 9vh;
        padding-bottom: 1vh;
        border-bottom: lightgrey 1px solid;
        position: fixed;
        top: 0;
        background: #ffffff;
        align-items: center;
        justify-content: space-between;
        display: flex;
        padding-left: 15vw;
        padding-right: 15vw;
    }

    .QuestionScreen__ask___QHDCu {
        color: red;
        font-size: 4vw;
    }

    .QuestionScreen__have___vTLkc {
        margin-top: 3vh;
        text-align: center;
        width: 40vw;
    }

    .QuestionScreen__headerTitle___nPWeH {
        text-align: center;
    }

    .QuestionScreen__form___BUF3_ {
        align-items: center;
        display: flex;
        flex-direction: column;
    }

    .QuestionScreen__input___vjUUf {
        width: 80%;
        height: 30vh;
        border-radius: 2vw;
        border: 1px #6060FF solid;
        padding: 2vw;
        margin-top: 5vh;
        font-size: 1vw;
    }

    .QuestionScreen__emailInput___Tl713 {
        width: 80%;
        height: 5vh;
        padding: 1vw;
        border-radius: 2vw;
        border: 1px #6060FF solid;
        margin-top: 1vh;
        font-size: 1vw;
    }

    .QuestionScreen__emailInput___Tl713:focus {
        outline: none;
    }

    .QuestionScreen__input___vjUUf:focus {
        outline: none;
    }

    .QuestionScreen__send___KNjrl {
        color: #6060FF;
        font-weight: bold;
        margin-top: 7vh;
        font-size: 1.25vw;
        cursor: pointer;
    }

    .QuestionScreen__thank___kkZJC {
        text-align: center;
        margin-top: 5vh;
    }

    .QuestionScreen__contact___FKnEr {
        color: #6060FF;
        margin-top: 5vh;
    }

}

.QuestionScreen__link_____8jv {
    text-decoration: none;
    color: #6060FF;
}

.QuestionScreen__link_____8jv:hover {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/website/css/QuestionScreen.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,+EAA+E;IAC/E,kFAAkF;IAClF,6EAA6E;IAC7E,8EAA8E;IAC9E,8EAA8E;IAC9E,kBAAkB;IAClB,qEAA6C;IAC7C,6DAAqC;IACrC,gCAAgC;IAChC,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI;QACI,+BAA+B;QAC/B,uBAAuB;IAC3B;IACA;QACI,iCAAiC;QACjC,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,uBAAuB;IAC3B;IACA;QACI,iCAAiC;QACjC,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,kCAAkC;QAClC,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,kCAAkC;QAClC,eAAe;QACf,MAAM;QACN,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;QAC9B,aAAa;QACb,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,YAAY;QACZ,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;AAEJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".loader {\n    font-size: 10px;\n    margin: 50px auto;\n    text-indent: -9999em;\n    width: 2vw;\n    height: 2vw;\n    border-radius: 50%;\n    background: #6060FF;\n    background: -moz-linear-gradient(left, #6060FF 10%, rgba(255, 255, 255, 0) 42%);\n    background: -webkit-linear-gradient(left, #6060FF 10%, rgba(255, 255, 255, 0) 42%);\n    background: -o-linear-gradient(left, #6060FF 10%, rgba(255, 255, 255, 0) 42%);\n    background: -ms-linear-gradient(left, #6060FF 10%, rgba(255, 255, 255, 0) 42%);\n    background: linear-gradient(to right, #6060FF 10%, rgba(255, 255, 255, 0) 42%);\n    position: relative;\n    -webkit-animation: load3 1.4s infinite linear;\n    animation: load3 1.4s infinite linear;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n}\n\n.loader:before {\n    width: 50%;\n    height: 50%;\n    background: #6060FF;\n    border-radius: 100% 0 0 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: '';\n}\n\n.loader:after {\n    background: #ffffff;\n    width: 75%;\n    height: 75%;\n    border-radius: 50%;\n    content: '';\n    margin: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n}\n\n@-webkit-keyframes load3 {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes load3 {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n@media screen and (max-width: 1100px) {\n    .loader {\n        width: 10vw;\n        height: 10vw;\n    }\n\n    .stiiick {\n        width: 40vw;\n        height: 10vw;\n        padding: 2.5vw\n    }\n\n    .headerContainer {\n        width: 100vw;\n        height: 10vh;\n        border-bottom: lightgrey 1px solid;\n        margin-top: -7vh;\n    }\n\n    .ask {\n        color: red;\n        font-size: 4vw;\n    }\n\n    .have {\n        margin-top: 3vh;\n        text-align: center;\n    }\n\n    .headerTitle {\n        text-align: center;\n    }\n\n    .form {\n        align-items: center;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .input {\n        width: 80vw;\n        height: 30vh;\n        border-radius: 5vw;\n        border: 1px #6060FF solid;\n        padding: 5vw;\n        font-size: 4vw;\n        margin-top: 5vh;\n    }\n\n    .emailInput {\n        width: 80vw;\n        height: 5vh;\n        padding: 2vw;\n        border-radius: 5vw;\n        border: 1px #6060FF solid;\n        font-size: 4vw;\n        margin-top: 1vh;\n    }\n\n    .emailInput:focus {\n        outline: none;\n    }\n\n    .input:focus {\n        outline: none;\n    }\n\n    .contact {\n        color: #6060FF;\n        margin-top: 5vh;\n        text-align: center;\n        font-size: 4vw;\n    }\n    .send {\n        color: #6060FF;\n        font-weight: bold;\n        margin-top: 7vh;\n        cursor: pointer;\n    }\n\n    .thank {\n        text-align: center;\n        margin-top: 5vh;\n    }\n}\n\n@media screen and (min-width: 1100px) {\n    .stiiick {\n        width: 28vh;\n        height: 7vh;\n        padding: 1vw;\n        object-fit: contain;\n        padding-left: 15vw;\n    }\n\n    .headerContainer {\n        width: 100vw;\n        height: 9vh;\n        padding-bottom: 1vh;\n        border-bottom: lightgrey 1px solid;\n        position: fixed;\n        top: 0;\n        background: #ffffff;\n        align-items: center;\n        justify-content: space-between;\n        display: flex;\n        padding-left: 15vw;\n        padding-right: 15vw;\n    }\n\n    .ask {\n        color: red;\n        font-size: 4vw;\n    }\n\n    .have {\n        margin-top: 3vh;\n        text-align: center;\n        width: 40vw;\n    }\n\n    .headerTitle {\n        text-align: center;\n    }\n\n    .form {\n        align-items: center;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .input {\n        width: 80%;\n        height: 30vh;\n        border-radius: 2vw;\n        border: 1px #6060FF solid;\n        padding: 2vw;\n        margin-top: 5vh;\n        font-size: 1vw;\n    }\n\n    .emailInput {\n        width: 80%;\n        height: 5vh;\n        padding: 1vw;\n        border-radius: 2vw;\n        border: 1px #6060FF solid;\n        margin-top: 1vh;\n        font-size: 1vw;\n    }\n\n    .emailInput:focus {\n        outline: none;\n    }\n\n    .input:focus {\n        outline: none;\n    }\n\n    .send {\n        color: #6060FF;\n        font-weight: bold;\n        margin-top: 7vh;\n        font-size: 1.25vw;\n        cursor: pointer;\n    }\n\n    .thank {\n        text-align: center;\n        margin-top: 5vh;\n    }\n\n    .contact {\n        color: #6060FF;\n        margin-top: 5vh;\n    }\n\n}\n\n.link {\n    text-decoration: none;\n    color: #6060FF;\n}\n\n.link:hover {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `QuestionScreen__loader___IN7f5`,
	"load3": `QuestionScreen__load3___bHL6r`,
	"stiiick": `QuestionScreen__stiiick___how8q`,
	"headerContainer": `QuestionScreen__headerContainer___wo0SM`,
	"ask": `QuestionScreen__ask___QHDCu`,
	"have": `QuestionScreen__have___vTLkc`,
	"headerTitle": `QuestionScreen__headerTitle___nPWeH`,
	"form": `QuestionScreen__form___BUF3_`,
	"input": `QuestionScreen__input___vjUUf`,
	"emailInput": `QuestionScreen__emailInput___Tl713`,
	"contact": `QuestionScreen__contact___FKnEr`,
	"send": `QuestionScreen__send___KNjrl`,
	"thank": `QuestionScreen__thank___kkZJC`,
	"link": `QuestionScreen__link_____8jv`
};
export default ___CSS_LOADER_EXPORT___;
